import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let subshellExample = `count=0
( count=99; echo "inside: $count" )
echo "outside: $count"
# inside: 99
# outside: 0 - the subshell's changes never escape it`

let groupExample = `count=0
{ count=99; echo "inside: $count"; }
echo "outside: $count"
# inside: 99
# outside: 99 - {} runs in the CURRENT shell`

let cdExample = `# Temporarily change directory without affecting the rest of the script
(
    cd /tmp/build
    make
)
pwd   # unchanged - still the original directory`

export default function SubshellsAndGrouping() {
    return (
        <div className={globalStyles.article}>
            <h1>Subshells & command grouping</h1>
            <p>Both <code>( ... )</code> and <code>{"{ ...; }"}</code> group commands so they can be
                redirected or chained as a unit, but they behave very differently.</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '450px'}}>
                    <thead>
                    <tr>
                        <th>Syntax</th>
                        <th>Runs in</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>( cmds )</code></td>
                        <td>A forked subshell — variable assignments, <code>cd</code>, and
                            <code> exit</code> stay local to it</td>
                    </tr>
                    <tr>
                        <td><code>{"{ cmds; }"}</code></td>
                        <td>The current shell — no fork, so side effects persist. Requires a space after
                            <code> {"{"}</code> and a trailing <code>;</code> before <code>{"}"}</code></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Variable scope</h3>
            <SyntaxHighlighter
                children={subshellExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
            <SyntaxHighlighter
                children={groupExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Common use — sandboxing a cd</h3>
            <SyntaxHighlighter
                children={cdExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
